import { render, staticRenderFns } from "./AddressCreate.vue?vue&type=template&id=4cbf681b&scoped=true&"
import script from "./AddressCreate.vue?vue&type=script&lang=js&"
export * from "./AddressCreate.vue?vue&type=script&lang=js&"
import style0 from "./AddressCreate.vue?vue&type=style&index=0&id=4cbf681b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf681b",
  null
  
)

export default component.exports